import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';



const styles = theme => ({

  container: {
    display: 'flex',
    flexWrap: 'wrap',
    paddingLeft:'1em'
  },




});


const theme = createMuiTheme({
  palette: {
    type: 'dark', // Switching the dark mode on is a single property value change.
  },
  typography: { useNextVariants: true },
});

const WorkSelect = ({classes, value, workTypes, handleChange}) => (
  <MuiThemeProvider theme={theme}>
  <form className={classes.container} noValidate autoComplete="off">

    <TextField
      filled={true}
      id="outlined-select-currency"
      select
      label="Select"
      className={classes.textField}

      value={value}
      onChange={handleChange}
      SelectProps={{
        MenuProps: {
          className: classes.menu,
        },
      }}
      classes={{
            root: classes.cssLabel,

          }}
      helperText="Please select medium"
      margin="normal"
      variant="outlined"
    >
    {workTypes.map(option => (
      <MenuItem key={option.value} value={option.value} >
        {option.label}
      </MenuItem>
    ))}
    </TextField>
  </form>
  </MuiThemeProvider>
)

export default withStyles(styles)(WorkSelect);
